import Super from '@simplepractice/ember-messaging-client/models/messaging-contact';

export default Super.extend({});
